import React, {forwardRef} from 'react';
import {
  TextInput as TextInputComponent,
  PasswordInput as PasswordInputComponent,
  TextRenderer as TextRendererComponent,
  PasswordRenderer as PasswordRendererComponent,
  LinkRender,
} from '@unthinkable/react-text-input';
import {
  TextAreaInput as TextAreaInputComponent,
  TextAreaRenderer as TextAreaRendererComponent,
} from '@unthinkable/react-text-area-input';

import {
  NumberInput as NumberInputComponent,
  NumberRenderer as NumberRendererComponent,
} from '@unthinkable/react-number-input';
import {DateRenderer as DateRendererComponent} from '@unthinkable/react-date-picker';

import {useStyles} from '@unthinkable/react-theme';
import {inputStyles, linkInputStyles} from './Editors.styles';

const WithStyles = (Component, InputStyles) => {
  const WrappedComponent = (props, ref) => {
    const styles = useStyles(InputStyles);
    return <Component styles={styles} ref={ref} {...props} />;
  };
  return forwardRef(WrappedComponent);
};

export const TextInput = WithStyles(TextInputComponent, inputStyles);
export const NumberInput = WithStyles(NumberInputComponent, inputStyles);
export const TextAreaInput = WithStyles(TextAreaInputComponent, inputStyles);
export const PasswordInput = WithStyles(PasswordInputComponent, inputStyles);

export const TextRenderer = WithStyles(TextRendererComponent, inputStyles);
export const PasswordRenderer = WithStyles(
  PasswordRendererComponent,
  inputStyles,
);
export const TextAreaRenderer = WithStyles(
  TextAreaRendererComponent,
  inputStyles,
);

export const DateRenderer = WithStyles(DateRendererComponent, inputStyles);
export const NumberRenderer = WithStyles(NumberRendererComponent, inputStyles);

export const LinkRenderer = WithStyles(LinkRender, linkInputStyles);
